export const REQUIRED_FIELD = "このフィールドは必須です。";
export const INVALID_EMAIL = "メールアドレスは無効です。";
export const PASSWORD_DO_NOT_MATCH = "パスワードは一致していません。";
export const PASSWORD_VALIDATION =
  "パスワードは12文字以上で、英大文字、小文字、数字、記号を少なくとも１つずつ含まれる必要です。";
export const INVALID_IP_ADDRESS = "IPアドレスは無効です。";
export const DUPLICATED_IP_ADDRESS = "アドレスIPは重複してはいけません";
export const REQUIRED_AT_LEAST_ONE_MEMBER =
  "メンバーを最低も1人選択してください。";
